<template>
    <v-flex>
        <v-flex v-if="displayInviteSomeone">
            <v-flex class="banner_view__options__invite">
                <v-flex tag="span" v-if="communityCategoryInfo" data-qe-id="ManageCommunity_CategoryInfo">
                    {{ communityCategoryInfo }} <i class="fas" :class="getLockIcon(communityCategory)"></i>
                </v-flex>
                <v-flex>
                    <v-btn
                        class="banner_view__options__invite__btn"
                        slot="activator"
                        @click="showInviteDialog()"
                        data-qe-id="invite-someone_btn"
                    >
                        {{ NetworkConstants.INVITE_SOMEONE }}
                    </v-btn>
                    <v-flex class="banner_view__options__invite__popup" text-xs-left v-if="isInviteSomeoneDialogOpen">
                        <v-btn
                            class="banner_view__options__invite__popup__close"
                            flat
                            icon
                            data-qe-id="show-invite_dialog_btn"
                            @click="showInviteDialog()"
                            ><i data-v-208291ac="" class="far fa-times-circle"></i
                        ></v-btn>
                        <v-flex text-xs-left>
                            <Invitesomeone
                                :displayForceJoin="isCommunityAdmin && currentCommunityView === userRoles.ADMIN"
                                @onInviteSomeoneSuccess="onInviteSomeoneSuccess"
                                @onInviteSomeoneFail="onInviteSomeoneFail"
                            >
                            </Invitesomeone>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-flex>

        <v-flex v-if="displayJoin"> 
            <v-flex class="banner_view__options__join">
                <v-flex v-if="communityCategory" data-qe-id="'Banner_CategoryInfo">
                    {{ communityCategoryInfo }} <i class="fas" :class="getLockIcon(communityCategory)"></i>
                </v-flex>
                <v-flex v-if="isNetworkPage && !isEligibleToJoin" data-qe-id="'Banner_Not_Eligible">
                    {{ NetworkConstants.YOU_ARE_NOT_ELIGIBLE_TO_JOIN_THIS_NETWORK }}
                </v-flex>
                <v-flex v-else>
                    <v-menu bottom right offset-y  v-if="!isJoinApplicationInProcess && !showApplicationSentMessage">
                        <v-btn
                            slot="activator"
                            @click="showTermsConditions()"
                            class="banner_view__options__join__btn"
                            data-qe-id="show-terms-conditions_btn"
                        >
                            {{ joinText }}
                        </v-btn>
                    </v-menu>
                    <v-flex tag="span" v-else data-qe-id="'Banner_Application_Has_Been_Sent">
                        {{ NetworkConstants.YOUR_JOIN_APPLICATION_HAS_BEEN_SENT }}
                    </v-flex>
                    <v-flex
                        class="banner_view__options__join__popup"
                        text-xs-left
                        v-if="isTermsCondtions && isNetworkPage"
                    >
                      <BusinessMarketplaceGroupTermsAndConditions
                          v-if="isBusinessMarketplaceGroup"
                          @close="displayEmailOptions"></BusinessMarketplaceGroupTermsAndConditions>
                        <TermsConditions v-else @close="displayEmailOptions"></TermsConditions>
                    </v-flex>

                    <v-flex
                        class="banner_view__options__join__popup"
                        text-xs-left
                        v-if="isTermsCondtions && isGroupPage"
                    >
                      <GroupsTermsConditions @close="displayEmailOptions"></GroupsTermsConditions>
                    </v-flex>
                    <v-flex class="banner_view__options__join__popup" v-if="isShowEmailOptions">
                        <v-card>
                            <v-card-title
                                class="banner_view__options__join__popup__title"
                                data-qe-id="Email_Preferences"
                            >
                                {{ homeBanner.PLEASE_SELECT_YOUR_EMAIL_PREFERENCES }}
                                <v-btn flat icon @click="displayEmailOptions(false)" data-qe-id="close-email-options">
                                    <i data-v-208291ac="" class="far fa-times-circle"></i>
                                </v-btn>
                            </v-card-title>
                            <v-card-text class="inner-scrollbar cstm-scrollbar">
                                <v-flex tag="p" data-qe-id="Correspondence_Alerts">{{
                                    homeBanner.SEND_ME_EMAIL_CORRESPONDENCE_ALERTS
                                }}</v-flex>
                                <v-select
                                    :items="emailOptions"
                                    :menu-props="{contentClass:'banner_view__options__join__popup__select'}"
                                    data-qe-id="email-options_dropdown"
                                    v-model="emailPreferences"
                                ></v-select>
                                <v-flex text-xs-center>
                                    <v-btn
                                        :loading="isJoinInProgress"
                                        class="primary_btn theme--light"
                                        data-qe-id="join-community_btn"
                                        @click="joinInCommunity()"
                                        >{{ homeBanner.JOIN }} {{ communityType }}
                                    </v-btn>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex class="success-popup" v-if="isSuccessfullyJoined" data-qe-id="success-popup_message">
            <v-btn flat icon @click="hideSuccessPopup()" data-qe-id="hide-success-popup_btn">
                <i data-v-208291ac="" class="far fa-times-circle"></i>
            </v-btn>
            {{ successStatusMessage }}
            <!--<v-flex tag="p" v-if="enrollmentType === Administration.DIRECT">
                <v-flex tag="em">
                    <a :href="'#/privacySettings/emailSettings'">{{Administration.CLICK_HERE}}</a> {{Administration.MANAGE_NETWORK_NOTIFICATIONS}}
                </v-flex>
            </v-flex>-->
        </v-flex>
        <v-flex v-if="displayResign" class="banner_view__options__resign">
            <v-flex v-if="communityName.toLowerCase() === NetworkConstants.PHISHING_NOTIFICATIONS_GROUP">
            <v-tooltip slot="append" top>                
                <a slot="activator" data-qe-id="reassign-dialog_open_link"><u><i>{{appCommonConstants.RESIGN_FROM}} {{$route.name}}</i></u></a>
                  <span>{{NetworkConstants.CONTACT_CONCIERGE_DESK_TO_RESIGN}}</span>
            </v-tooltip>
        </v-flex>
        <v-flex v-else>
            <ResignCommunity
                @onResignSucess="onResignSucess"
                @onResignFailure="onResignFailure"
                :communityName="communityName"
                :communityIdPromise="communityIdPromise"
    ></ResignCommunity>
  </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { storeGetters } from '../../store/storeGetters.constant';
import { storeMutation } from '../../store/storeMutations.constant';
import { storeAction } from '../../store/storeActions.constant';
import { homeBanner, userRoles, routerNames, appCommonConstants } from '../appCommon.constants';
import { Administration, NetworkConstants } from '../NetworkPage/NetworkConstants';
import Invitesomeone from '../NetworkPage/InviteSomeone';
import TermsConditions from '../NetworkPage/TermsandConditions';
import GroupsTermsConditions from '../GroupPage/GroupsTermsandConditions';
import ResignCommunity from '../NetworkPage/ResignCommunity/ResignCommunity';
import orderBy from 'lodash/orderBy';
import { commonEnvVariables } from "@/commonEnvVariables";
import BusinessMarketplaceGroupTermsAndConditions
  from "@/components/GroupPage/BusinessMarketplaceGroupTermsAndConditions";

export default {
    name: 'ManageCommunityOptions',
    components: {
      BusinessMarketplaceGroupTermsAndConditions,
        Invitesomeone,
        TermsConditions,
        ResignCommunity,
        GroupsTermsConditions,
    },
    data: () => {
        return {
            userRoles,
            NetworkConstants,
            isInviteSomeoneDialogOpen: false,
            isTermsCondtions: false,
            homeBanner,
            isSuccessfullyJoined: false,
            isShowEmailOptions: false,
            emailPreferences: 'Daily Digest',
            successStatusMessage: '',
            Administration,
            showApplicationSentMessage: false,
            appCommonConstants,
            communityjoin: {
                CommunityId: '',
                EmailPreference: '',
                EnrollmentType: '',
            },
            isJoinInProgress: false,
            shown: false,
        };
    },
    props: {
        displayInviteSomeone: {
            type: Boolean,
            default: false,
        },
        displayJoin: {
            type: Boolean,
            default: false,
        },
        displayResign: {
            type: Boolean,
            default: false,
        },
        communityCategory: {
            type: String,
            default: '',
        },
        enrollmentType: {
            type: String,
            default: '',
        },
        isEligibleToJoin: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters({
            usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
            currentCommunityView: `${[storeGetters.currentCommunityView]}`,
            joinNetwork: `network/${storeGetters.joinNetwork}`,
            communityInfo: `chapter/${storeGetters.communityInfo}`,
            communityIdPromise: `${[storeGetters.communityIdPromise]}`,
            communityPendingRequests: `network/${[storeGetters.communityPendingRequests]}`,
        }),
        joinText() {
            if (this.enrollmentType.toLowerCase().includes(this.Administration.EMAIL.toLowerCase())) {
                return this.homeBanner.APPLY_TO_JOIN;
            } else if (this.enrollmentType.toLowerCase() === this.Administration.DIRECT.toLowerCase()) {
                return this.homeBanner.JOIN;
            }
            return this.homeBanner.APPLY_TO_JOIN;
        },
        isJoinApplicationInProcess() {
            if (
                this.communityPendingRequests &&
                this.communityPendingRequests.some(r => r.communityId === this.$route.params.communityId)
            ) {
                return (
                    this.communityPendingRequests.find(r => r.communityId === this.$route.params.communityId)
                        .approvalStatus === 'P'
                );
            }
            return false;
        },
        communityCategoryInfo() {
            return `${this.communityCategory} ${this.communityType}`;
        },
        emailOptions() {
            const options = this.NetworkConstants.EMAIL_OPTIONS;
            // if (this.$route.name.toLowerCase() === 'group') {
            //     options.unshift(this.NetworkConstants.WHEN_ANYONE_POST);
            // }
            return options;
        },
        communityName() {
            return this.communityInfo && this.communityInfo.name ? this.communityInfo.name : '';
        },
        communityType() {
            return this.$route.name;
        },
        isNetworkPage() {
            return this.$route.name === routerNames.NETWORK;
        },
        isGroupPage() {
            return this.$route.name === routerNames.GROUP;
        },
        communityIdFromRoute() {
          return this.$route.params.communityId || null;
        },
        isBusinessMarketplaceGroup() {
          return this.communityIdFromRoute
              && this.communityIdFromRoute === commonEnvVariables().BUSINESS_MARKETPLACE_COMMUNITY_ID;
        },
    },
    watch: {
        usersCommunitiesList() {
            this.resetToggleValues();
        },
        currentCommunityView(view) {
            if (view === this.userRoles.ADMIN) {
                this.isInviteSomeoneDialogOpen = false;
            }
        },
    },
    methods: {
        ...mapActions({
            applyToJoinNetwork: `network/${storeAction.applyToJoinNetwork}`,
            getusersCommunitiesList: `chapter/${storeAction.getusersCommunitiesList}`,
        }),
        ...mapMutations({
            toggleRequestedMembers: `network/${storeMutation.toggleRequestedMembers}`,
            toggleInviteSomeone: `network/${storeMutation.toggleInviteSomeone}`,
        }),
        resetToggleValues() {
            this.toggleRequestedMembers(false);
            this.toggleInviteSomeone(false);
        },
        showTermsConditions() {
            this.isTermsCondtions = true;
        },
        getLockIcon(communityCategory) {
            switch (communityCategory) {
                case this.appCommonConstants.PUBLIC:
                    return `fa-lock-open`;
                default:
                    return `fa-lock`;
            }
        },
        displayEmailOptions(value) {
            if (value) {
                this.isTermsCondtions = false;
                this.isShowEmailOptions = true;
            } else {
                this.isTermsCondtions = false;
                this.isShowEmailOptions = false;
            }
        },
        hideSuccessPopup() {
            this.isTermsCondtions = false;
            this.isShowEmailOptions = false;
            this.isSuccessfullyJoined = false;
        },
        showInviteDialog() {
            this.isInviteSomeoneDialogOpen = !this.isInviteSomeoneDialogOpen;
        },
        onInviteSomeoneSuccess() {
            this.isInviteSomeoneDialogOpen = false;
            this.showSuccessStatusPopup(this.NetworkConstants.SUCCESSFULLY_INVITED);
        },
        onInviteSomeoneFail(message) {
            this.showSuccessStatusPopup(message);
        },
        onResignSucess(communityData) {
            const SUCCESS_MESSAGE = this.NetworkConstants.SUCCESSFULLY_RESIGNED + this.$route.name;
            this.showSuccessStatusPopup(SUCCESS_MESSAGE, communityData, null, true);
        },
        onResignFailure() {
            const ERROR_MESSAGE = this.NetworkConstants.ERROR_WHILE_RESIGNING + this.$route.name;
            this.showSuccessStatusPopup(ERROR_MESSAGE);
        },
        showSuccessStatusPopup(
            message,
            resignCallbackCommunity = null,
            joinCallbackCommunity = null,
            refreshUserCommunityList = false,
        ) {
            this.isSuccessfullyJoined = true;
            this.successStatusMessage = message;
            if (this.communityCategory !== this.appCommonConstants.PUBLIC) {
                this.showApplicationSentMessage = true;
            }
            if (refreshUserCommunityList) {
                this.getusersCommunitiesList();
            }
            setTimeout(() => {
                this.isSuccessfullyJoined = false;
                const communityType = this.$route.name.toLowerCase();
                this.successStatusMessage = '';
                if (resignCallbackCommunity) {
                    if (resignCallbackCommunity.communityId) {
                        this.$router.push({
                            path: `/${communityType}/${resignCallbackCommunity.communityId}`,
                            query: { name: resignCallbackCommunity.name },
                        });
                    } else {
                        this.$router.push({
                            path: `/home`,
                        });
                    }
                }
                if (joinCallbackCommunity && this.communityCategory === this.appCommonConstants.PUBLIC) {
                    if (joinCallbackCommunity.communityId) {
                        this.$router.push({
                            path: `/${communityType}/${joinCallbackCommunity.communityId}`,
                            query: { name: joinCallbackCommunity.name },
                        });
                    } else {
                        this.$router.go();
                    }
                }
            }, 3000);
        },
        joinInCommunity() {
            this.isJoinInProgress = true;
            this.communityjoin.CommunityId = this.$route.params.communityId;
            this.communityjoin.EmailPreference =
                this.emailPreferences === this.NetworkConstants.WHEN_ANYONE_POST
                    ? this.emailPreferences.replace(/\s/g, '')
                    : this.emailPreferences.replace('Digest', '').trim();
            this.communityjoin.EnrollmentType = this.enrollmentType.replace(' ', '').trim();
            this.applyToJoinNetwork(JSON.parse(JSON.stringify(this.communityjoin)))
                .then(() => {
                    this.isTermsCondtions = false;
                    this.isShowEmailOptions = false;
                    let callBackCommunity;
                    if (
                        this.usersCommunitiesList.some(o => o.communityType.toLowerCase() === this.$route.name.toLowerCase())
                    ) {
                        const communityData = orderBy(
                            this.usersCommunitiesList.filter(o => o.communityType.toLowerCase() === this.$route.name.toLowerCase()),
                            ['name'],
                            ['asc'],
                        )[0];
                        callBackCommunity = { communityId: communityData.communityId, name: communityData.name };
                    } else {
                        callBackCommunity = { communityId: null };
                    }
                    if (this.enrollmentType.toLowerCase().includes(this.Administration.EMAIL.toLowerCase())) {
                        this.showSuccessStatusPopup(this.Administration.YOUR_APPLICATION_SENT, null, callBackCommunity);
                    } else if (this.enrollmentType.toLowerCase().includes(this.Administration.DIRECT.toLowerCase())) {
                        this.showSuccessStatusPopup(
                            this.Administration.YOU_SUCCESSFULLY_JOINED,
                            null,
                            callBackCommunity,
                            true,
                        );
                    }
                })
                .catch((error) => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        if (error.response.data.message === this.Administration.YOUR_ARE_ALREADY_MEMBER) {
                            this.showSuccessStatusPopup(this.Administration.YOUR_ARE_ALREADY_MEMBER, null, null, true);
                            this.isShowEmailOptions = false;
                        } else if (error.response.data.message === this.Administration.REQUEST_SUBMITTED_PENDING) {
                            this.showSuccessStatusPopup(this.Administration.REQUEST_SUBMITTED_PENDING, null, null, true);
                            this.isShowEmailOptions = false;
                        } else {
                            this.showSuccessStatusPopup(error.response.data.message, null, null, true);
                        }
                    } else if (this.enrollmentType === this.Administration.EMAIL_REQUEST) {
                        this.showSuccessStatusPopup(this.Administration.ERROR_WHILE_SENDING_APPLICATION);
                    } else if (this.enrollmentType === this.Administration.DIRECT) {
                        this.showSuccessStatusPopup(this.Administration.ERROR_WHILE_JOINING);
                    }
                }).finally(() => {
                    this.isJoinInProgress = false;
                });
        },
    },
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.success-popup {
    min-width: 365px;
    position: absolute;
    right: 20px;
    top: 15px;
    background: $ypo-gold;
    padding: 10px 30px 10px 10px;
    border-radius: 4px;
    z-index: 100;
    text-align: left;

    .v-btn {
        position: absolute;
        right: 6px;
        top: 6px;
        width: auto;
        height: auto;

        i {
            color: $white;
        }
    }

    p {
        color: $white;
        margin-bottom: 0;
    }

    em {
        color: $white;

        a {
            text-decoration: none;
        }
    }

    @include breakpoint(xs) {
        min-width: 300px;
        max-width: 300px;
    }
}

@include breakpoint(xs) {
    .banner_view__options__join__popup__select {
        z-index: 100 !important;
    }
}
</style>
